import axios from "axios";

import {
  SET_COST_CENTERS_LIST,
  UNSET_COST_CENTERS_LIST
} from "@/store/mutation-types";

import {
  saveUpdateCostCenters,
  getConstCentersList
} from "@/store/api"

//initial state
const state = {
  getConstCentersList: [],
};

//Getters
const getters = {
  getConstCentersList(state){
    return state.getConstCentersList;
  }
};

//Mutations
const mutations = {
  [SET_COST_CENTERS_LIST](state, data){
    state.getConstCentersList = data;
  },
  [UNSET_COST_CENTERS_LIST](state){
    state.getConstCentersList = []
  }
};

// actions
const actions = {
  saveUpdateCostCenters({commit} , data){
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      axios.post(saveUpdateCostCenters, data)
      .then(function(response){
        resolve(response);
      })
      .catch(function (error) {
        reject(error);
      })
      .then((always) => {
        commit("UNSET_LOADING")
      });
    });
  },

  getConstCentersList({commit}, data){
    return new Promise((resolve, reject) => {
      axios.get(getConstCentersList)
      .then(function (response){
        commit("SET_COST_CENTERS_LIST", response.data.data)
        resolve(response);
      })
      .catch(function (error) {
        commit("UNSET_COST_CENTERS_LIST")
        reject(error);
      })
      .then((always) => {

      });
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}